<template>
  <v-container id="projects">
    <p class="text-h2 text-center my-10">Projects</p>
    <v-row
      v-for="i in projectMenu"
      :key="i.title"
      id="project-view"
      data-aos="fade-up"
      class="mt-10 justify-center align-center"
    >
      <v-col cols="12" md="5">
        <div class="head-text">
          <span class="text-h3 text-md-left">
            {{ i.title }}
            <br />
            <span v-for="icon in i.icons" :key="icon">
              <v-icon large>{{ icon }}</v-icon>
            </span>
          </span>
          <p class="font-italic text-h5 text-md-left">{{ i.date }}</p>
          <v-divider class="subtext-divider" />
        </div>
        <p class="text-body-1 text-lg-h5 mt-10">
          {{ i.description }}
        </p>

        <!-- Extra dynamic component if present -->
        <component v-if="i.extraComponent" :is="i.extraComponent" />

        <v-btn
          :x-large="$vuetify.breakpoint.smAndUp"
          class="mr-10"
          color="primary"
          v-if="i.live_website"
          :href="i.live_website"
          :target="!i.live_website_no_target ? `_blank` : ``"
          >{{
            i.live_website_title ? i.live_website_title : "Live website"
          }}</v-btn
        >
        <v-btn
          :x-large="$vuetify.breakpoint.smAndUp"
          large
          color="source_code_button white--text"
          v-if="i.source_code"
          :href="i.source_code"
          target="_blank"
          >Source code</v-btn
        >

        <p class="text-caption mt-10" v-if="i.caption">
          {{ i.caption }}
        </p>
      </v-col>
      <v-col cols="12" md="7" class="mt-5 mt-lg-0">
        <v-img
          contain
          v-bind:src="require('../assets/' + i.img_url)"
          eager
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import conquizMobile from "./misc/conquizMobile.vue";
export default {
  components: {
    conquizMobile,
  },
  data() {
    return {
      projectMenu: [
        {
          title: "ShareBear",
          date: "Sep 2021 - Feb 2022",
          description:
            "Online web-platform for sharing files between devices without any authentication for the user. Files are automatically deleted when expired after 3 days.",
          img_url: "sharebear.webp",
          icons: ["$cSharpIcon", "$reactIcon", "$typescriptIcon"],
          live_website: "https://sharebear.vercel.app/",
          source_code: "https://github.com/BoostedPenguin/ShareBear",
        },
        {
          title: "PenQuiz",
          date: "Sep 2021 - May 2022",
          description:
            "Online round-based trivia game taking place in Antarctica. Choose from multiple playable characters with various abilities. Capture territories from other players with engaging trivia questions. Scoring is based on the amount of territories and points you own.",
          img_url: "conquiz.webp",
          icons: [
            "$cSharpIcon",
            "$reactIcon",
            "$rabbitMqIcon",
            "$kubernetesIcon",
          ],
          live_website: "https://penquiz.netlify.app/",
          source_code: "https://github.com/BoostedPenguin/PenQuiz",
          caption:
            "* Website may be sleeping and will need 10-15 seconds to turn itself on.",
          extraComponent: conquizMobile,
        },
        {
          title: "SafeCrypt",
          date: "June 2021 - Sep 2021",
          description:
            "I invented an Android application, which encrypts / decrypts users media items using AES-256 cipher and gives the ability to preview them on the spot.",
          img_url: "safecrypt.webp",
          icons: ["$androidIcon", "$kotlinIcon"],
          live_website_title: "Play store",
          live_website_no_target: true,
          live_website:
            "https://play.google.com/store/apps/details?id=com.penguinstudio.safecrypt",
          source_code: "https://github.com/BoostedPenguin/SafeCrypt",
        },
        {
          title: "PenguinEngine",
          date: "Sep 2020 - Jan 2021",
          description:
            "I created a trip advisor website, which uses Google services to create personalized suggestions for every user. Each customer has the ability to make a wishlist with destinations and trips.",
          img_url: "penguin_engine.webp",
          icons: ["$cSharpIcon", "$vueIcon"],
          live_website: "",
          source_code: "https://github.com/BoostedPenguin/PenguinEngine",
        },
        {
          title: "DanyArt",
          date: "June 2020 - July 2020",
          description:
            "I designed and currently maintain a website for a local artist so they can promote and sell their art. The website acts as a catalogue and the client has the ability to manage their items.",
          img_url: "danyart.webp",
          icons: ["$laravelIcon", "$vueIcon"],
          live_website: "https://danyart.art/",
          source_code: "",
        },
        {
          title: "RogueLike Game",
          date: "Jan 2020 - Feb 2020",
          description:
            "Roguelike game based around random encounters, loot, enemy fights and character management. Learned the fundamentals of C# and object-oriented programming while working on this project.",
          img_url: "roguelike.webp",
          icons: ["$cSharpIcon"],
          live_website: "",
          source_code: "https://github.com/BoostedPenguin/RogueLikeGame",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
#project-view {
  padding-top: 10vh;
  margin-bottom: 20vh;
}

.remove-underline {
  text-decoration: none;
}

.head-text {
  text-align: justify;
}

.subtext-divider {
  background-color: rgb(104, 104, 104);
  width: 20%;
}
</style>